var map = {
	"./all_for_one.banner.jpg": "48d5",
	"./all_for_one.cover.jpg": "f7e4",
	"./coco_style.banner.jpg": "9af3",
	"./mini_but_many.banner.jpg": "ab25",
	"./mini_but_many.cover.jpg": "d4d4",
	"./total_look.banner.jpg": "cd1d",
	"./total_look.cover.jpg": "01ec",
	"./triple_crush.banner.jpg": "f589",
	"./triple_crush.cover.jpg": "80b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f141";